<script>
/* COMPOSANTS */
import AkInputText from '@components/v2/input/AkInputText.vue';
import MultiSelect from 'primevue/multiselect';
import AkDropdown from '@components/v2/input/AkDropdown.vue';
import AkAutocomplete from '@components/v2/input/AkAutocomplete.vue';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@/mixins/sidebarMixin';
import accommodationTypeConst from '@mixins/const/accommodationTypeConst';
import residenceTypeConst from '@mixins/const/residenceTypeConst';
import ownerTypesConst from '@mixins/const/ownerTypesConst';
import companyMixin from '@mixins/companyMixin';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import mandatAutocompleteMixin from '@mixins/autocomplete/mandatAutocompleteMixin';

export default {
  components: {
    AkButtonFooterSidebarFilter,
    AkAutocomplete,
    AkInputText,
    AkDropdown,
    MultiSelect,
  },
  mixins: [
    permissionsMixin,
    companyMixin,
    utilsMixin,
    sidebarMixin,
    accommodationTypeConst,
    mandatAutocompleteMixin,
    accommodationAutocompleteMixin,
    residenceTypeConst,
    ownerTypesConst,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      enabledStateConst: [
        {label: this.$t('owner.all'), value: null},
        {label: this.$t('owner.enabled_only'), value: true},
        {label: this.$t('owner.disabled_only'), value: false},
      ],
    };
  },
  mounted() {},
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      if (this.$refs.accommodationAutocomplete) {
        this.$refs.accommodationAutocomplete.reset();
      }
      if (this.$refs.mandatAutocomplete) {
        this.$refs.mandatAutocomplete.reset();
      }
      this.callback[1]();
      this.itemSelect();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-if="this.isGas()"
      v-model="currentValue.companyIds"
      :options="this.companies"
      :loading="this.loadingCompanies"
      :placeholder="$t('employee.company')"
      class="form-control"
      option-label="name"
      filter
      filter-placeholder="Filtrer"
      @change="itemSelect"
      option-value="id" />
    <AkInputText
      @valueChange="itemSelect"
      v-model="currentValue.ownerName"
      :placeholder="$t('interlocutor.proprietaire')"
      :inline="true" />
    <AkAutocomplete
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :inline="true"
      :minLengthToLaunchSearch="3"
      option-value="id"
      option-label="display"
      @item-select="itemSelect"
      :placeholder="$t('accommodation_title')"
      :search-method="this.autocompleteAccommodation"
      :search-label="this.autocompleteAccommodationQuery"
      :init-method="this.autocompleteAccommodationById" />

    <AkAutocomplete
      ref="mandatAutocomplete"
      v-model="currentValue.mandatId"
      :inline="true"
      :label="$t('mandat.details')"
      option-value="id"
      option-label="num"
      @item-select="itemSelect"
      :force-selection="false"
      :init-method="this.autocompleteMandatById"
      :search-method="this.autocompleteMandat" />

    <AkInputText
      @valueChange="itemSelect"
      v-model="currentValue.email"
      :placeholder="$t('contact.email')"
      :inline="true" />
    <AkInputText
      @valueChange="itemSelect"
      v-model="currentValue.phone"
      input-type="tel"
      :placeholder="$t('contact.phone')"
      :inline="true" />
    <MultiSelect
      @change="itemSelect"
      v-model="currentValue.ownerTypes"
      inline
      :placeholder="$t('prospect.ownerType')"
      :options="ownerTypesConstFilter"
      class="form-control"
      option-label="label"
      option-value="value" />
    <AkDropdown
      @valueChange="itemSelect"
      v-model="currentValue.userEnabled"
      inline
      :label="$t('status')"
      :options="enabledStateConst"
      option-label="label"
      option-value="value" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search()" @reset="reset()" />
  </form>
</template>
